// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import loading from  '@/components/loading'
import success from  '@/components/success'
import app from '@/assets/js/common'
import axios from 'axios'

Vue.config.productionTip = false;
Vue.use(require('vue-wechat-title'));
Vue.prototype.$axios = axios;
Vue.prototype.$url = 'http://ljmes.ayunlian.com';
Vue.prototype.app = app;

const  ADD_COUNT = 'ADD_COUNT';//常量代替事件类型，是的代码更清晰
const  REMOVE_COUNT = 'REMOVE_COUNT';
// 注册状态管理全局参数
var store = new Vuex.Store({
  state:{
    token:'',
    title:''
  },
  mutations:{
    [ADD_COUNT] (state , token,){
      state.token = localStorage.getItem('token');
    },
    [REMOVE_COUNT] (state, token){
      state.token = localStorage.removeItem('token');
    },
  }
});

router.beforeEach((to,from,next) =>{
  store.state.token = localStorage.getItem('token');
  if (to.meta.requireAuth) { //判断该路由是否需要登录权限
    if( store.state.token == 'undefined' || store.state.token == '' ){
      next({
        path: '/login',
        // query: {redirect: to.fullPath}
        //将跳转的路由path作为参数，登录成功后跳转到该页面
      });
    }
    if (store.state.token !== '') { //通过vuex state 获取当前的token 是否存储
      next();
    }
    if( store.state.token == null ) {
      next({
        path: '/login',
        // query: {redirect: to.fullPath}
        //将跳转的路由path作为参数，登录成功后跳转到该页面

      });
    }
  }else{
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  loading,
  success,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js